import { tableState, tableMutations, tableActions, tableGetters } from "@tt/vue-components";
import entityService from "@/services/EntityService";
import isActiveFilter from "@/store/modules/openingHoursRecurringList/filters/isActiveFilter";
import isOpenFilter from "@/store/modules/openingHoursRecurringList/filters/isOpenFilter";

const openingHoursRecurringList = {
    namespaced: true,
    modules: {
        isActiveFilter,
        isOpenFilter
    },
    state: {
        ...tableState,
        pagination: {itemsPerPage: 20, itemsPage: 1},
        footerProps: {"items-per-page-options": [10, 20, 40, 80]},
        recurringHours: null,
        selection: []
    },
    mutations: {
        ...tableMutations,
        SET_ITEM(state, item) {
            state.item = item
        },
        SET_SELECTION(state, data) {
            state.selection = data;
        }
    },
    actions: {
        ...tableActions,
        setSelection({commit}, data) {
            commit("SET_SELECTION", data)
        },
        fetchItems({state, commit}, refresh = false) {
            if (refresh || state.items.length === 0) {

                commit("SET_LOADING", true);
                const params = {pagination: state.pagination, sorting: state.sorting, search: state.search};

                entityService.openingHoursRecurring.list(params)
                    .then(json => {
                        if (json) {
                            commit("SET_ITEMS", json);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
                    .finally(() => {
                        commit("SET_LOADING", false);
                    });

            }

        },
        selectItem({ commit }, item) {
            commit("SET_ITEM", item);
        },
        edit({commit}, recurringHours) {
            return new Promise((resolve, reject) => {
                entityService.openingHoursRecurring.patch(recurringHours.id, recurringHours)
                    .then((response) => {
                        commit("EDIT_ITEM", response);
                        resolve();
                    })
                    .catch(err => {
                        reject(err["hydra:description"]);
                    });
            });
        },
        add({commit}, recurringHours) {
            return new Promise((resolve, reject) => {
                entityService.openingHoursRecurring.create(recurringHours)
                    .then((data) => {
                        commit("ADD_ITEM", data);
                        resolve();
                    })
                    .catch(err => {
                        reject(err["hydra:description"]);
                    });
            });
        },
        patch({commit}, data) {
            return new Promise((resolve, reject) => {
                entityService.openingHoursRecurring.patch(data.id, data.body)
                    .then((response) => {
                        console.log(response);
                        commit("EDIT_ITEM", response);
                        resolve();
                    })
                    .catch(err => {
                        reject(err["hydra:description"]);
                    });
            });
        },
        delete({commit}, item) {
            return new Promise((resolve, reject) => {
                entityService.openingHoursRecurring.delete(item.id)
                    .then(() => {
                        commit("DELETE_ITEM", item.id);
                        resolve();
                    })
                    .catch(err => {
                        reject(err["hydra:description"]);
                    });
            });
        },
        // /opening_hours_recurrings:update_opening_hours_recurring
        updateRecurring(id) {
            return new Promise((resolve, reject) => {
                entityService.openingHoursRecurring.updateRecurring(id)
                    .then(() => {
                        resolve();
                    })
                    .catch(err => {
                        reject(err["hydra:description"]);
                    });
            });
        }
    },
    getters: {
        ...tableGetters,
    }
};

export default openingHoursRecurringList;
